import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

// A table row that can be dragged by its handle to reorder books.
export const SortableBookRow = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = { transform: CSS.Translate.toString(transform), transition, position: "relative", zIndex: isDragging ? 20 : undefined };
  return (
    <tr ref={setNodeRef} style={style} data-testid={`admin-book-row-${id}`}
      className={`border-t border-[#E5DCCB] transition-colors ${isDragging ? "bg-[#FFFBEB] shadow-xl" : "bg-white hover:bg-[#FAF7F2]"}`}>
      <td className="px-2 py-4">
        <button ref={setActivatorNodeRef} {...attributes} {...listeners} aria-label="اسحب لتغيير الترتيب" title="اسحب لتغيير الترتيب"
          className="p-2 rounded-full cursor-grab active:cursor-grabbing touch-none text-stone-600 hover:bg-[#F2ECE1] hover:text-[#1C1917]" data-testid={`admin-book-drag-${id}`}>
          <GripVertical className="w-5 h-5" />
        </button>
      </td>
      {children}
    </tr>
  );
};
